import React, { useRef, useState } from "react"
import { useSelector } from "react-redux"
import { selectAviaSearchDates } from "../../../../../app/reducers/book/aviaSearchSlice"
import { useClickOutside } from "../../hooks"
import { motion, AnimatePresence } from "framer-motion"
import DateModalTopHead from "./DateModalTopHead"
import DateModalBottomHead from "./DateModalBottomHead"
import DateModalCalendar from "./DateModalCalendar"
import DateModalFooter from "./DateModalFooter"
import { cn } from "../../../../../lib"

const DateModal = ({ showModal, onClose, onAction, className, isDeparture }) => {
  const dates = useSelector(selectAviaSearchDates)
  const { to, from } = dates

  const modalRef = useRef(null)

  useClickOutside(modalRef, onClose)

  return (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: -10 }}
          transition={{ duration: 0.18, ease: "easeOut" }}
          className={cn(
            "fixed bottom-0 left-0 md:left-auto w-full md:absolute md:top-[60px] z-50 md:w-max md:min-w-[630px] h-[425px]",
            className
          )}
        >
          <div
            ref={modalRef}
            className="bg-white rounded-lg overflow-hidden w-full relative shadow-xl"
          >
            <div>
              {/* <DateModalTopHead mode={dates.mode} from={from} to={to} isDeparture={isDeparture} /> */}
              <DateModalBottomHead to={to} from={from} isDeparture={isDeparture} />
            </div>
            <div className="px-6 py-2 bg-white">
              <DateModalCalendar datesState={dates} isDeparture={isDeparture} />
            </div>
            {/* <DateModalFooter /> */}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default DateModal
